import { AbiItem } from 'web3-utils'
// import UniversalProfileAbi_v_0_12_1 from '@lukso/universalprofile-contracts/compatibility-abis/UniversalProfile-v0.12.0.json'
// TODO: Use this instead once it's included in lsp-smart-contracts
// import UniversalProfileInitAbi_v_0_12_1 from '@lukso/universalprofile-contracts/compatibility-abis/UniversalProfileInit-v0.12.0.json'

import {
  ContractEventType,
  ContractEventTypeArray,
} from '@/shared/models/ContractEvent'
import { UniversalProfileAbi_v_0_12_1 } from './UniversalProfileEvents'
import { UniversalProfileInitAbi_v_0_12_1 } from './UniversalProfileInitEvents'

export const upEventsABI: AbiItem[] = [
  ...(UniversalProfileAbi_v_0_12_1 as AbiItem[]).filter(
    ({ type, name }) =>
      type === 'event' &&
      name &&
      ContractEventTypeArray.includes(name as ContractEventType)
  ),
  ...(UniversalProfileInitAbi_v_0_12_1 as AbiItem[]).filter(
    ({ type, name }) =>
      type == 'event' && name === ContractEventType.INITIALIZED
  ),
]
